module.exports = __webpack_public_path__ + "img/page_item4.ea97277e.png";